import { asNumber } from "@frontend/unhideschool/app/helpers/utility-functions";

import { PlaylistItemMediaAdapterRequestDataModel, PlaylistItemOtpRequestDataModel, PlaylistItemRequestDataModel } from "./player-item-request-data.model";

export function formatTotalTime(group, format?) {
  if (format == 'minutes') {
    return (group.totaltime * 1000) < 3600 ? new Date(group.totaltime * 1000).toISOString().substr(11, 5) : new Date(group.totaltime * 1000).toISOString().substr(14, 5);

  }
  const time = new Date(group.totaltime * 1000).toISOString().substr(11, 5).replace(':', 'h')
  return asNumber(time.split('h')[0]) >= 10 ? time : time.substring(1, time.length);
}


export type PlaylistItemContentModel = [string, string];

export interface PlaylistItemToolbarModel {
  icon: string,
  value: number,
  labelDesktop: string;
  labelMobile: string
}

export interface PlaylistTagModel {
  softwareTagList: any;
  regularTagList: any;

}

export class PlaylistItem {
  progress?: number;
  thumbnail?: string;
  groupname?: string;
  title?: string;
  description?: string;
  otp?: PlaylistItemOtpRequestDataModel;
  mediaadapter?: PlaylistItemMediaAdapterRequestDataModel;
  content?: PlaylistItemContentModel;
  totaltime?: string;
  orderedpostpartid?: any;
  postpartid?: any;
  views?: any;
  likes?: any;
  toolbarItems?: PlaylistItemToolbarModel[];
  videoid?: number;
  commentsTotalCount?: number;
  timecode?: number;
  tagLists?: PlaylistTagModel;
  finished?: boolean;
  position?: number;
  playbackRate?: number;

  constructor(playlistItem?: PlaylistItemRequestDataModel, toolbarItems?: PlaylistItemToolbarModel[]) {
    this.progress = playlistItem.progress ? playlistItem.progress : 0;
    this.thumbnail = playlistItem.thumbnail;
    this.groupname = playlistItem.groupname;
    this.title = playlistItem.title;
    this.description = playlistItem.description;
    this.content = JSON.parse(playlistItem.content ? playlistItem.content : null);
    this.totaltime = this.content ? formatTotalTime({ totaltime: this.content[1] }, 'minutes') : '';
    this.orderedpostpartid = playlistItem.orderedpostpartid;
    this.postpartid = playlistItem.postpartid;
    this.position = playlistItem.position;
    this.likes = playlistItem.likes;
    this.views = playlistItem.views;
    this.commentsTotalCount = playlistItem?.comments?.totalCount;
    this.otp = playlistItem.otp;
    this.mediaadapter = playlistItem.mediaadapter;
    this.toolbarItems = toolbarItems;
    if (playlistItem.content && playlistItem.view && (playlistItem.progress == 100
      && asNumber(playlistItem.view.timecode) == asNumber(this.content[1])
      || asNumber(playlistItem.view.timecode) == asNumber(this.content[1]) - 1)) {
      this.timecode = 0;
    } else {
      this.timecode = parseFloat(playlistItem?.view?.timecode);
    }
    this.finished = playlistItem?.view?.finished;

    if (playlistItem.tags && playlistItem.tags.length > 0) {
      this.tagLists = {
        softwareTagList: playlistItem.tags.filter(tag => tag.tagtypeid == 2), // softwarelist = tagtypeid = 2
        regularTagList: playlistItem.tags.filter(tag => tag.tagtypeid == 1) // softwarelist = tagtypeid = 1
      }
    }

  }

}


export interface PlayerItemModel {
  progress?: number;
  thumbnail?: string;
  groupname?: string;
  title?: string;
  description?: string;
  otp?: PlaylistItemOtpRequestDataModel;
  mediaadapter?: PlaylistItemMediaAdapterRequestDataModel;
  content?: PlaylistItemContentModel;
  totaltime?: string;
  orderedpostpartid?: any;
  postpartid?: any;
  views?: any;
  likes?: any;
  toolbarItems?: PlaylistItemToolbarModel[];
  videoid?: number;
  commentsTotalCount?: number;
  timecode?: number;
  tagLists?: PlaylistTagModel;
  finished?: boolean;
  position?: number;
  playbackRate?: number;

}

export const PlayerItemBuilder = (playlistItem: PlaylistItemRequestDataModel, toolbarItems: PlaylistItemToolbarModel[]): PlayerItemModel => {
  const {
    progress = 0,
    thumbnail,
    groupname,
    title,
    description,
    content: rawContent = '[\"0\", 0]',
    orderedpostpartid,
    postpartid,
    position,
    likes,
    views,
    comments,
    otp,
    mediaadapter,
    tags,
    view,
  } = playlistItem;

  const commentsTotalCount = comments?.totalCount || 0;
  const content = JSON.parse(rawContent);
  const totaltime = content && content[1] ? formatTotalTime({ totaltime: content[1] }, 'minutes') : '';
  const hasValidContent = content && view;
  const timecode = hasValidContent ? parseFloat(view.timecode) : 0;
  const finished = view?.finished;
  const tagLists = tags && tags.length > 0 ? filterTagListByType(playlistItem) : null;

  const teste = {
    progress,
    thumbnail,
    groupname,
    title,
    description,
    content,
    totaltime,
    orderedpostpartid,
    postpartid,
    position,
    likes,
    views,
    commentsTotalCount,
    otp,
    mediaadapter,
    toolbarItems,
    timecode,
    finished,
    tagLists
  };
  return teste

}


export const filterTagListByType = (playlistItem: PlaylistItemRequestDataModel): PlaylistTagModel => {
  return {
    softwareTagList: playlistItem.tags.filter(tag => tag.tagtypeid == 2), // softwarelist = tagtypeid = 2
    regularTagList: playlistItem.tags.filter(tag => tag.tagtypeid == 1) // softwarelist = tagtypeid = 1
  }
}

